// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../../node_modules/postcss-loader/dist/cjs.js!../style/colors.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.KZIGJQTFtC_dqdFPVc62 {
  text-decoration: none;
  font-weight: 500;
  border-radius: 5px;
  padding: 8px 36px;
  cursor: pointer;
  outline: none;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: .3s;
  font-weight: medium;
}

.v7mNfBkk2ikspcLRuFi1 {
  border: none;
}

.iduLTeo4GkzcqyKIJp5e.v7mNfBkk2ikspcLRuFi1 {
  background-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-button-primary"]};
  color: white;
}

.iduLTeo4GkzcqyKIJp5e.v7mNfBkk2ikspcLRuFi1:hover {
  background-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-button-primary-hover"]};
}

.iduLTeo4GkzcqyKIJp5e.v7mNfBkk2ikspcLRuFi1:focus {
  background-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-button-primary-focus"]};
}

.oGzSZzrEq9JWUHzBpqIg.v7mNfBkk2ikspcLRuFi1 {
  background-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-button-secondary"]};
  color: white;
}

.oGzSZzrEq9JWUHzBpqIg.v7mNfBkk2ikspcLRuFi1:hover {
  background-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-button-secondary-hover"]};
  color: white;
}

.oGzSZzrEq9JWUHzBpqIg.v7mNfBkk2ikspcLRuFi1:focus {
  background-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-button-secondary-focus"]};
  color: white;
}

.n3nNaan3wbnHxdWG67rf.v7mNfBkk2ikspcLRuFi1 {
  background-color: #C0BFCF;
  color: white;
  cursor: not-allowed;
  box-shadow: none;
}

.n3nNaan3wbnHxdWG67rf.YgtUFo7spBnxS6YJm1Ns {
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-gray"]};
  border: 2px solid ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-gray"]};
}

.iduLTeo4GkzcqyKIJp5e.YgtUFo7spBnxS6YJm1Ns {
  border: 2px solid ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-button-primary"]};
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-button-primary"]};
  background: none;
}

.iduLTeo4GkzcqyKIJp5e.YgtUFo7spBnxS6YJm1Ns:hover {
  border: 2px solid ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-button-primary-hover"]};
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-button-primary-hover"]};
  background-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-red-bg"]};
}

.iduLTeo4GkzcqyKIJp5e.YgtUFo7spBnxS6YJm1Ns:focus {
  border: 2px solid ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-button-primary-focus"]};
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-button-primary"]};
  background-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-red-bg"]};
}

.oGzSZzrEq9JWUHzBpqIg.YgtUFo7spBnxS6YJm1Ns {
  border: 2px solid ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-button-secondary"]};
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-button-secondary"]};
  background: none;
}

.oGzSZzrEq9JWUHzBpqIg.YgtUFo7spBnxS6YJm1Ns:hover {
  border: 2px solid ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-button-secondary-hover"]};
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-button-secondary-hover"]};
  background-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-purple-bg"]};
}

.oGzSZzrEq9JWUHzBpqIg.YgtUFo7spBnxS6YJm1Ns:focus {
  border: 2px solid ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-button-secondary-focus"]};
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-button-secondary"]};
  background-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-purple-bg"]};
}

.xzcc74I0fQVpoalobTaP {
  border: none;
  background: none;
}

.iduLTeo4GkzcqyKIJp5e.xzcc74I0fQVpoalobTaP {
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-button-primary"]};
  padding: 0;
}

.iduLTeo4GkzcqyKIJp5e.xzcc74I0fQVpoalobTaP:hover {
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-button-primary-hover"]};
}

.iduLTeo4GkzcqyKIJp5e.xzcc74I0fQVpoalobTaP:focus {
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-button-primary-focus"]};
}

.oGzSZzrEq9JWUHzBpqIg.xzcc74I0fQVpoalobTaP {
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-button-secondary"]};
  padding: 0;
}

.oGzSZzrEq9JWUHzBpqIg.xzcc74I0fQVpoalobTaP:hover {
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-button-secondary-hover"]};
}

.oGzSZzrEq9JWUHzBpqIg.xzcc74I0fQVpoalobTaP:focus {
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-button-secondary-focus"]};
}

.n3nNaan3wbnHxdWG67rf.xzcc74I0fQVpoalobTaP {
  color: #C0BFCF;
}

.S5MNjqwJvyoiFcNHgstn {
  margin-right: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.ynQdFwwmEIs_XP_I_UEL {
  height: 38px;
  min-width: 88px;
  font-size: 16px;
}

.iiasxSplH_RCwwCPjDqy {
  height: 48px;
  min-width: 112px;
  font-size: 18px;
}

.tNt5qUVCnztS9OiE9bRu {
  height: 72px;
  min-width: 150px;
  font-size: 18px;
}
`, "",{"version":3,"sources":["webpack://./src/components/library/Button/Button.module.css"],"names":[],"mappings":"AAGA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,8DAAsC;EACtC,YAAY;AACd;;AAEA;EACE,8DAA4C;AAC9C;;AAEA;EACE,8DAA4C;AAC9C;;AAEA;EACE,8DAAwC;EACxC,YAAY;AACd;;AAEA;EACE,8DAA8C;EAC9C,YAAY;AACd;;AAEA;EACE,8DAA8C;EAC9C,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mDAAiB;EACjB,8DAA4B;AAC9B;;AAEA;EACE,8DAAsC;EACtC,mDAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,8DAA4C;EAC5C,mDAAiC;EACjC,8DAA8B;AAChC;;AAEA;EACE,8DAA4C;EAC5C,mDAA2B;EAC3B,8DAA8B;AAChC;;AAEA;EACE,8DAAwC;EACxC,mDAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,8DAA8C;EAC9C,mDAAmC;EACnC,8DAAiC;AACnC;;AAEA;EACE,8DAA8C;EAC9C,mDAA6B;EAC7B,8DAAiC;AACnC;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,mDAA2B;EAC3B,UAAU;AACZ;;AAEA;EACE,mDAAiC;AACnC;;AAEA;EACE,mDAAiC;AACnC;;AAEA;EACE,mDAA6B;EAC7B,UAAU;AACZ;;AAEA;EACE,mDAAmC;AACrC;;AAEA;EACE,mDAAmC;AACrC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB","sourcesContent":["@value colors: \"../style/colors.css\";\r\n@value color-gray, color-red-bg, color-purple-bg, color-button-primary, color-button-primary-hover, color-button-primary-focus, color-button-secondary, color-button-secondary-hover, color-button-secondary-focus, color-purple-bg, color-success from colors;\r\n\r\n.button {\r\n  text-decoration: none;\r\n  font-weight: 500;\r\n  border-radius: 5px;\r\n  padding: 8px 36px;\r\n  cursor: pointer;\r\n  outline: none;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  transition: .3s;\r\n  font-weight: medium;\r\n}\r\n\r\n.fill {\r\n  border: none;\r\n}\r\n\r\n.primary.fill {\r\n  background-color: color-button-primary;\r\n  color: white;\r\n}\r\n\r\n.primary.fill:hover {\r\n  background-color: color-button-primary-hover;\r\n}\r\n\r\n.primary.fill:focus {\r\n  background-color: color-button-primary-focus;\r\n}\r\n\r\n.secondary.fill {\r\n  background-color: color-button-secondary;\r\n  color: white;\r\n}\r\n\r\n.secondary.fill:hover {\r\n  background-color: color-button-secondary-hover;\r\n  color: white;\r\n}\r\n\r\n.secondary.fill:focus {\r\n  background-color: color-button-secondary-focus;\r\n  color: white;\r\n}\r\n\r\n.disabled.fill {\r\n  background-color: #C0BFCF;\r\n  color: white;\r\n  cursor: not-allowed;\r\n  box-shadow: none;\r\n}\r\n\r\n.disabled.outline {\r\n  color: color-gray;\r\n  border: 2px solid color-gray;\r\n}\r\n\r\n.primary.outline {\r\n  border: 2px solid color-button-primary;\r\n  color: color-button-primary;\r\n  background: none;\r\n}\r\n\r\n.primary.outline:hover {\r\n  border: 2px solid color-button-primary-hover;\r\n  color: color-button-primary-hover;\r\n  background-color: color-red-bg;\r\n}\r\n\r\n.primary.outline:focus {\r\n  border: 2px solid color-button-primary-focus;\r\n  color: color-button-primary;\r\n  background-color: color-red-bg;\r\n}\r\n\r\n.secondary.outline {\r\n  border: 2px solid color-button-secondary;\r\n  color: color-button-secondary;\r\n  background: none;\r\n}\r\n\r\n.secondary.outline:hover {\r\n  border: 2px solid color-button-secondary-hover;\r\n  color: color-button-secondary-hover;\r\n  background-color: color-purple-bg;\r\n}\r\n\r\n.secondary.outline:focus {\r\n  border: 2px solid color-button-secondary-focus;\r\n  color: color-button-secondary;\r\n  background-color: color-purple-bg;\r\n}\r\n\r\n.ghost {\r\n  border: none;\r\n  background: none;\r\n}\r\n\r\n.primary.ghost {\r\n  color: color-button-primary;\r\n  padding: 0;\r\n}\r\n\r\n.primary.ghost:hover {\r\n  color: color-button-primary-hover;\r\n}\r\n\r\n.primary.ghost:focus {\r\n  color: color-button-primary-focus;\r\n}\r\n\r\n.secondary.ghost {\r\n  color: color-button-secondary;\r\n  padding: 0;\r\n}\r\n\r\n.secondary.ghost:hover {\r\n  color: color-button-secondary-hover;\r\n}\r\n\r\n.secondary.ghost:focus {\r\n  color: color-button-secondary-focus;\r\n}\r\n\r\n.disabled.ghost {\r\n  color: #C0BFCF;\r\n}\r\n\r\n.icon {\r\n  margin-right: 8px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.small {\r\n  height: 38px;\r\n  min-width: 88px;\r\n  font-size: 16px;\r\n}\r\n\r\n.medium {\r\n  height: 48px;\r\n  min-width: 112px;\r\n  font-size: 18px;\r\n}\r\n\r\n.large {\r\n  height: 72px;\r\n  min-width: 150px;\r\n  font-size: 18px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"colors": `"../style/colors.css"`,
	"color-gray": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-gray"]}`,
	"color-red-bg": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-red-bg"]}`,
	"color-purple-bg": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-purple-bg"]}`,
	"color-button-primary": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-button-primary"]}`,
	"color-button-primary-hover": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-button-primary-hover"]}`,
	"color-button-primary-focus": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-button-primary-focus"]}`,
	"color-button-secondary": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-button-secondary"]}`,
	"color-button-secondary-hover": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-button-secondary-hover"]}`,
	"color-button-secondary-focus": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-button-secondary-focus"]}`,
	"color-success": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-success"]}`,
	"button": `KZIGJQTFtC_dqdFPVc62`,
	"fill": `v7mNfBkk2ikspcLRuFi1`,
	"primary": `iduLTeo4GkzcqyKIJp5e`,
	"secondary": `oGzSZzrEq9JWUHzBpqIg`,
	"disabled": `n3nNaan3wbnHxdWG67rf`,
	"outline": `YgtUFo7spBnxS6YJm1Ns`,
	"ghost": `xzcc74I0fQVpoalobTaP`,
	"icon": `S5MNjqwJvyoiFcNHgstn`,
	"small": `ynQdFwwmEIs_XP_I_UEL`,
	"medium": `iiasxSplH_RCwwCPjDqy`,
	"large": `tNt5qUVCnztS9OiE9bRu`
};
export default ___CSS_LOADER_EXPORT___;
